<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center" [style]="{ height: '100vh', backgroundColor: '#3f51b5' }">
    <mat-card appearance="outlined" class="box" style="min-width: 440px">
        <mat-card-header>
            <mat-card-title>
                <div style="margin-bottom: 10px; font-size: x-large">Create Password</div>
            </mat-card-title>
        </mat-card-header>
        <form [formGroup]="passwordFormGroup" (ngSubmit)="onFormSubmit()">
            <mat-form-field class="full-width">
                <input matInput type="password" placeholder="Old Password" name="oldPassword" formControlName="oldPassword" />
                @if (passwordFormGroup.controls["oldPassword"].hasError("required")) {
                    <mat-error>This field is required</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="full-width">
                <input matInput type="password" placeholder="New Password" name="newPassword" formControlName="newPassword" />
                @if (passwordFormGroup.controls["newPassword"].hasError("required")) {
                    <mat-error>This field is required</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="full-width">
                <input matInput type="password" placeholder="Confirm Password" name="confirmPassword" formControlName="confirmPassword" />
                @if (passwordFormGroup.controls["confirmPassword"].hasError("required")) {
                    <mat-error>This field is required</mat-error>
                }
                @if (passwordFormGroup.controls["confirmPassword"].hasError("passwordMismatch")) {
                    <mat-error>Passwords do not match</mat-error>
                }
            </mat-form-field>
            <mat-card-actions>
                <button mat-raised-button color="primary" class="btn-block" type="submit">Change Password</button>
            </mat-card-actions>
        </form>
    </mat-card>
</div>
